import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';

type BackCallback = (...args: any) => void;

class BackManagerClass {
  private callback: BackCallback | null = null;
  private enabled = false;
  private navigating = false;

  constructor() {
    window.addEventListener('popstate', this.handler);
  }

  private handler = (event: PopStateEvent) => {
    if (!this.enabled || this.navigating) {
      return;
    }

    event.preventDefault();

    this.navigating = true;

    if (this.callback) {
      this.callback();
    }

    window.history.pushState(null, '', window.location.pathname);

    setTimeout(() => {
      this.navigating = false;
    }, 0);
  };

  set(callback: BackCallback) {
    this.callback = callback;
    this.enabled = true;

    window.history.pushState(null, '', window.location.pathname);
  }

  clear() {
    this.enabled = false;
    this.callback = null;
  }
}

export const BackManager = new BackManagerClass();

export const useCallBackOnBack = (callback: BackCallback = () => {}, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    if (!isMobile) return;

    BackManager.set(callback);

    return () => {
      BackManager.clear();
    };
  }, [enabled]);
};
